<!-- ant-layout-has-sider is normally set by nz-layout's ContentChildren(NzSiderComponent)
     query, which can't see the sider inside <app-xwai-sidebar>, so it's set by hand. -->
<nz-layout class="layout ant-layout-has-sider">
  <app-xwai-sidebar [lockedCollapsed]="embedded ? !expanded : null" />

  <nz-layout class="right-layout">
    <nz-content>
      <nz-spin [nzSpinning]="isLoading() || initialising()">
      <nz-header>
        <div class="convo-heading">
          @if(activeConversation(); as convo){
          <span>{{convo.name}}</span>
          <!-- <span class="thread-id">{{threadId()}}</span> -->
          <br>
          <span class="description">{{convo.description}}</span>
          }@else {
          <span>New conversation</span>

          <br>
          }
        </div>
        <div>
          <span class="thread-id">{{threadId()}}</span>
          <button nz-button nzSize="small" nz-tooltip nzTooltipTitle="Export conversation" nzTooltipPlacement="top"
            nz-dropdown [nzDropdownMenu]="chatMenu" nzTrigger="click" class="actions-more"
            [disabled]="messages().length === 0" style="margin-right: 15px;" nzShape="circle" nzType="text">
            <span nz-icon nzType="more" nzTheme="outline" style="color: black"></span>
          </button>
        </div>
      </nz-header>
      <div #scrollContainer class="stream-wrapper" [class.stream-wrapper--expanded]="expanded">
        <app-xwai-v2-stream />
      </div>
      </nz-spin>
    </nz-content>

    <nz-footer>
      @if(threadId()){
      <app-xwai-input class="footer-input" [class.footer-input--expanded]="expanded" />
      }
      <p class="disclaimer">
        XWAI can make mistakes — verify important results.
      </p>
    </nz-footer>
  </nz-layout>
</nz-layout>


<nz-dropdown-menu #chatMenu="nzDropdownMenu">
  <ul nz-menu>
    <li nz-menu-item (click)="exportMarkdown()">
      <span nz-icon nzType="file-markdown" nzTheme="outline" class="menu-icon"></span>
      Export as Markdown
    </li>
    <li nz-menu-item (click)="downloadHistory()">
      <span nz-icon nzType="download" nzTheme="outline" class="menu-icon"></span>
      Download as JSON
    </li>
  </ul>
</nz-dropdown-menu>